import {
  Directive,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { DropdownDirective } from '@macs-frontend/web/features/ui-kit/directives/dropdown.directive';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: '[UIKitDropdownMenu]',
})
export class DropdownMenuDirective {
  @Input() content: any;

  @HostBinding('class.dropdown-menu') 'true': any;
  @HostBinding('class.active') 'dropdown.isOpen()': any;

  @Output() public clickOutside: EventEmitter<any> = new EventEmitter();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: {
    parentElement: { hasAttribute: (arg0: string) => any };
    hasAttribute: (arg0: string) => any;
  }) {
    if (
      targetElement instanceof HTMLElement &&
      targetElement.parentElement.hasAttribute('UIKitDropdownToggle')
    ) {
      return;
    }
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if (
      !clickedInside ||
      (targetElement instanceof HTMLElement && targetElement.hasAttribute('href'))
    ) {
      this.dropdown.close();
    } else {
      this.dropdown.open();
    }
  }

  constructor(
    @Inject(forwardRef(() => DropdownDirective))
    public dropdown: any,
    private elementRef: ElementRef,
  ) {}
}
